var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":true,"large":_vm.large,"extraLarge":_vm.extraLarge},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Hópaleit")]),_c('br'),_c('GroupSearch',{attrs:{"slidebar":true,"term":_vm.term,"module":_vm.module,"group":_vm.group,"department":_vm.department},on:{"changeGroup":_vm.closeSlidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }